<template>
  <div class="TableBaseStatus">
    <v-card-text v-if="searchActive && dataVals !== null">
      <v-text-field
        v-model="search"
        append-icon="search"
        label="Buscar"
        single-line
        hide-details
      ></v-text-field>
    </v-card-text>

    <v-data-table
      dense
      :headers="headers"
      :items="dataVals"
      :search="search"
      :custom-filter="customFilter"
      no-results-text="No se encontro el término buscado"
      no-data-text="No hay datos disponibles"
      multi-sort
      disable-initial-sort
      class="elevation-1"
      loading="Cargando... Por favor espere."
      rows-per-page-text="Filas por página:"
    >
      <template slot="items" slot-scope="props">
        <td
          v-for="col in columns"
          :key="col.id"
          :align="align(props.item[col])"
        >
          {{ props.item[col] }}
        </td>
        <td class="text-xs-center">
          <v-tooltip left>
            <template v-slot:activator="{ on }">
              <v-icon
                v-on="on"
                large
                :color="color(props.item.estado).color"
              >info</v-icon>
            </template>
            <span> {{ color(props.item.estado).msg }}</span>
          </v-tooltip>
        </td>
      </template>
    </v-data-table>
  </div>
</template>

<script>
export default {
  name: 'TableBaseStatus',

  /**
   * Elementos que recibe el componente para renderizar
   */
  props: {
    /** Cabecera de la tabla */
    headers: {
      type: Array,
      required: true
    },
    /** Contenido de la tabla */
    dataVals: {
      type: Array,
      required: true
    },
    /** Habilita o desahbilita la busqueda */
    searchActive: {
      type: Boolean,
      required: false,
      default: false
    }
  },

  data: function () {
    return {
      search: '',
      rowsPerPageItems: [5, 10, 20, 50, { 'text': '$vuetify.dataIterator.rowsPerPageAll', 'value': -1 }]
    }
  },

  computed: {
    /**
     * Devuelve los valores de los identificadores de las columnas de la tabla
     * @return {[Array]} valores de los id de columnas
     */
    'columns': function columns () {
      if (this.headers.length === 0) {
        return []
      }

      var colVals = []
      this.headers.forEach(function (element) {
        colVals.push(element.value)
      })
      colVals.pop()
      return colVals
    }
  },

  methods: {
    /**
     * Determina la alineación de la celda, si es string se alinea a la izquierda
     * para los demas casos se alinea a la derecha
     * @param  {string} val El valor a evaluar
     * @return {string}      La alineación a usar
     */
    align (val) {
      let algn = 'right'
      if (typeof val === 'string' && val[val.length - 1] !== '%') {
        algn = 'left'
      }
      return algn
    },

    /**
     * Determina el color segun dias sin enviar
     * @param  {int} color numero sin envios
     */
    color (val) {
      let color = {}
      switch (val) {
        case 1: // No hay sentencia "break" en el 'case 0:', por lo tanto este caso también será ejecutado
          color.color = 'success'
          color.msg = 'Menos de 2 días, sin subir encuestas'
          break
        case 2:
          color.color = 'warning'
          color.msg = 'Menos de 3 días, sin subir encuestas'
          break
        case 3:
          color.color = 'error'
          color.msg = 'Menos de 5 días, sin subir encuestas'
          break
        case 4:
          color.color = 'black'
          color.msg = '5 días o mas, sin subir encuestas'
          break
        default:
          color.color = 'gray'
          color.msg = 'No hay registro de días'
      }
      return color
    }
  }
}
</script>
